module.exports = __webpack_public_path__ + "static/media/jfm_at_psg.caf55245.jpeg";